import React from 'react';

const ItemDetailModal = ({ item, onClose, language }) => {
  return (
    <div className="item-detail-container">
      <div className="item-detail-card">
        <img width={250}
          src={item.image_link || item.thumb_link} // Use image_link if available, else thumb_link
          alt={item[`${language}_name`]}
          className="item-detail-image"
        />
        <h2 className="item-detail-name">{item[`${language}_name`]}</h2>
        <p className="item-detail-price">IQD {item.price.toLocaleString()}</p>
        <p  style={{fontSize:"14px",fontWeight:"bold"}}>{item.description}</p>
      </div>
    </div>
  );
};

export default ItemDetailModal;